/**
 * Use Case: Criar Tarefa
 * Orquestra a criação de uma nova tarefa
 */

import { ITaskRepository } from '../../../domain/repositories/ITaskRepository';
import { Task } from '../../../domain/entities/Task';

export interface CreateTaskDTO {
    leadId?: string | null;
    title: string;
    dueDate: Date;
    description?: string;
    type?: string;
    organizationId?: string;
    assignedTo?: string;
}

export class CreateTaskUseCase {
    constructor(private readonly taskRepository: ITaskRepository) { }

    async execute(dto: CreateTaskDTO): Promise<Task> {
        // Gera ID temporário
        const tempId = `temp_${Date.now()}`;

        // Cria entidade (validações automáticas)
        const task = new Task(
            tempId,
            dto.leadId || null,
            dto.title,
            dto.dueDate,
            false, // não completada
            dto.description || '',
            dto.type || '',
            dto.assignedTo
        );

        // Persiste e recebe a tarefa atualizada com ID real
        const savedTask = await this.taskRepository.save(task, dto.organizationId);

        return savedTask;
    }
}
